import React, { Fragment } from 'react';
import { Grid } from '@material-ui/core';
import DatePicker from 'src/ui/library/DatePicker';
import Dropdown from 'src/ui/library/Dropdown';
import TextInput from 'src/ui/library/TextInput';
import IconButton from '@material-ui/core/IconButton';
import RadioButtonChecked from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUnchecked from '@material-ui/icons/RadioButtonUnchecked';
import intl from 'react-intl-universal';

class WhatIfEmployeeRowPres extends React.Component {
  handleOnChange = ({ target }) => {
    const { id, onChange } = this.props;
    if (onChange) {
      onChange(id, target);
    }
  };

  render() {
    const { employees, id, lookups, countriesDictionary, mode } = this.props;
    const empKeys = Object.keys(employees);
    const employee = employees[id];

    const homeCountryList = Object.keys(countriesDictionary);
    const hostCountriesDictionary = employee.homeCountry ? countriesDictionary[employee.homeCountry].countries : null;
    const hostCountryList = hostCountriesDictionary ? Object.keys(hostCountriesDictionary) : [];

    return (
      <Grid className="whatif-employee-row" item xs={12}>
        <div className="whatif-employee-row-radio-button">
          {mode !== 'detail' && (
            <Fragment>
              {empKeys.length > 1 && (
                <Fragment>
                  {!employee.selected && (
                    <IconButton onClick={() => this.handleOnChange({ target: { name: 'selected', value: true } })}>
                      <RadioButtonUnchecked style={{ color: 'black' }} />
                    </IconButton>
                  )}
                  {employee.selected && (
                    <IconButton onClick={() => this.handleOnChange({ target: { name: 'selected', value: false } })}>
                      <RadioButtonChecked style={{ color: 'black' }} />
                    </IconButton>
                  )}
                </Fragment>
              )}
            </Fragment>
          )}
        </div>
        <Grid className="whatif-employee-row-grid" container>
          <Grid item xs={3} className="whatif-employee-row-input">
            <Dropdown
              required={true}
              options={homeCountryList.map(key => ({ value: countriesDictionary[key].name, label: countriesDictionary[key].name }))}
              id={`homeCountry`}
              name={`homeCountry`}
              label={intl.get('whatif.inputs.homeCountry')}
              onChange={this.handleOnChange}
              value={employee.homeCountry}
            />
          </Grid>
          <Grid item xs={3} className="whatif-employee-row-input">
            <Dropdown
              required={true}
              options={hostCountryList.map(key => ({ value: hostCountriesDictionary[key].name, label: hostCountriesDictionary[key].name }))}
              id={`hostCountry`}
              name={`hostCountry`}
              label={intl.get('whatif.inputs.hostCountry')}
              onChange={this.handleOnChange}
              value={employee.hostCountry}
            />
          </Grid>
          <Grid item xs={3} className="whatif-employee-row-input">
            <Dropdown
              required={true}
              options={lookups.levelsList.map(item => ({ value: item, label: item }))}
              id={`level`}
              name={`level`}
              label={intl.get('whatif.inputs.level')}
              onChange={this.handleOnChange}
              value={employee.level}
            />
          </Grid>
          <Grid item xs={3} className="whatif-employee-row-input">
            <Dropdown
              required={true}
              options={Object.keys(lookups.policyList).map(key => ({ value: lookups.policyList[key], label: key }))}
              id={`policy`}
              name={`policy`}
              label={intl.get('whatif.inputs.policy')}
              onChange={this.handleOnChange}
              value={employee.policy}
            />
          </Grid>
          <Grid item xs={3} className="whatif-employee-row-input">
            <Dropdown
              required={true}
              options={lookups.maritalStatusList.map(item => ({ value: item, label: item }))}
              id={`maritalStatus`}
              name={`maritalStatus`}
              label={intl.get('whatif.inputs.maritalStatus')}
              onChange={this.handleOnChange}
              value={employee.maritalStatus}
            />
          </Grid>
          <Grid item xs={3} className="whatif-employee-row-input">
            <TextInput
              required={true}
              id={`familySize`}
              name={`familySize`}
              label={intl.get('whatif.inputs.familySize')}
              placeholder={1}
              value={employee.familySize}
              onChange={enteredFamilySize => this.handleOnChange({ target: { name: `familySize`, value: enteredFamilySize.target.value } })}
              errorText="Please enter a valid family size"
              hasError={
                isNaN(employee.familySize) || !Number.isInteger(Number(employee.familySize)) || Number(employee.familySize) < 0
              }></TextInput>
          </Grid>
          {employee.familySize && employee.familySize > 1 && (
            <Grid item xs={3} className="whatif-employee-row-input">
              <TextInput
                required={true}
                id={`numOfSchoolAgedChildren`}
                name={`numOfSchoolAgedChildren`}
                label={intl.get('whatif.inputs.numOfSchoolAgedChildren')}
                placeholder={0}
                value={employee.numOfSchoolAgedChildren}
                onChange={enteredNumOfChildren =>
                  this.handleOnChange({ target: { name: `numOfSchoolAgedChildren`, value: enteredNumOfChildren.target.value } })
                }
                errorText="Please enter a valid number for school aged chidren"
                hasError={
                  isNaN(employee.numOfSchoolAgedChildren) ||
                  !Number.isInteger(Number(employee.numOfSchoolAgedChildren)) ||
                  Number(employee.numOfSchoolAgedChildren) < 0
                }></TextInput>
            </Grid>
          )}
          <Grid item xs={3} className="whatif-employee-row-input">
            <Dropdown
              required={true}
              options={[...Array(10).keys()].map(item => ({ value: item + 1, label: (item + 1).toString() }))}
              id={`noOfEmployees`}
              name={`noOfEmployees`}
              label={intl.get('whatif.inputs.noOfEmployees')}
              onChange={this.handleOnChange}
              value={employee.noOfEmployees}
            />
          </Grid>
          <Grid item xs={3} className="whatif-employee-row-input">
            <TextInput
              required={true}
              id={`salary`}
              name={`salary`}
              label={intl.get('whatif.inputs.salary')}
              value={employee.salary}
              onChange={salary => this.handleOnChange({ target: { name: `salary`, value: salary.target.value } })}
              errorText="Please enter a valid salary number"
              hasError={isNaN(employee.salary) || Number(employee.salary) < 0}></TextInput>
          </Grid>
          <Grid item xs={3} className="whatif-employee-row-input">
            <DatePicker
              required={true}
              id={`startDate`}
              name={`startDate`}
              label={intl.get('whatif.inputs.startDate')}
              from={2018}
              onChange={date => this.handleOnChange({ target: { name: `startDate`, value: date } })}
              value={employee.startDate}
            />
          </Grid>
          <Grid item xs={3} className="whatif-employee-row-input">
            <DatePicker
              required={true}
              id={`endDate`}
              name={`endDate`}
              label={intl.get('whatif.inputs.endDate')}
              from={2018}
              onChange={date => this.handleOnChange({ target: { name: `endDate`, value: date } })}
              value={employee.endDate}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default WhatIfEmployeeRowPres;
